const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://automation.takyon247.net';

export default API_BASE_URL;
